import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

// Bars grow to fill the space but are CAPPED at COL_MAX so few months don't
// stretch into awkwardly fat bars — they sit at a comfortable width, centred with
// a fixed gap between them and white space on the ends. Many months shrink to fit
// (no scroll). The chart area itself is capped so a full-width card doesn't spread
// the bars too thin.
const COL_MAX = 80

/** Shared month-bar layout for the DSD Center charts, so spacing is identical
 *  across them. `children(i)` renders the bar(s) for month i (use w-full). */
export function MonthBars({
  months,
  onHover,
  isActive,
  children,
}: {
  months: string[]
  onHover?: (i: number | null) => void
  isActive?: (i: number) => boolean
  children: (i: number) => ReactNode
}) {
  return (
    <div className="mx-auto w-full max-w-[560px]">
      <div className="flex items-end justify-center gap-2 sm:gap-5">
        {months.map((m, i) => {
          const [mon, yy] = m.split('-')
          const firstOfYear = i === 0 || months[i - 1].split('-')[1] !== yy
          return (
            <div
              key={m + i}
              className="flex min-w-0 flex-1 flex-col items-center justify-end gap-1"
              style={{ maxWidth: COL_MAX }}
              onMouseEnter={onHover ? () => onHover(i) : undefined}
              onMouseLeave={onHover ? () => onHover(null) : undefined}
            >
              {children(i)}
              <span className={cn('text-[9px] leading-none', isActive?.(i) ? 'font-medium text-stone-600 dark:text-stone-300' : 'text-stone-400')}>{mon}</span>
              <span className="text-[8px] leading-none text-stone-300 dark:text-stone-600">{firstOfYear ? `20${yy}` : ' '}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
